import { Controller } from "@hotwired/stimulus";

const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

/**
 * Writes the browser's IANA timezone into a shared cookie so the next request can convert Instants.
 * Does not rewrite clocks in the browser.
 */
export default class extends Controller {
   connect() {
      this.writeCookie();
   }

   private writeCookie(): void {
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (!timeZone)
         return;

      const secure = window.location.protocol === "https:" ? "; Secure" : "";

      const host = window.location.hostname;
      const domain = host === "mvdm.io" || host.endsWith(".mvdm.io") ? "; Domain=.mvdm.io" : "";

      document.cookie = `browser-timezone=${timeZone}; path=/; max-age=${COOKIE_MAX_AGE_SECONDS}; SameSite=Lax${secure}${domain}`;
   }
}
